import React, { useState, useEffect } from 'react'
import FetchApi from './customhooks/functionFetchApi'
import { FaUserLock, FaUser, FaLock } from "react-icons/fa6";

const Login = () => {
    const FetchApis = new FetchApi();
    const [isUser, setIsUser] = useState({ username: '', password: '' })

    useEffect(() => {
        sessionStorage.clear();
    }, [])

    const loginguser = (e) => {
        e.preventDefault();
        FetchApis.FethcPost(`/account/login`, isUser).then((results) => {
            if (results == undefined) {
                alert('เกิดความผิดพลาด user and password invalid')
            }
            else if (results.status == 200) {
                console.log(results.data[0])
                if (results.data[0].isActive == "1") {
                    sessionStorage.setItem("UserName", results.data[0].name);
                    sessionStorage.setItem("aId", results.data[0].aId);
                    sessionStorage.setItem("Token", results.token);
                    sessionStorage.setItem("EmCode", results.data[0].employeeId)
                    sessionStorage.setItem("DepartId", results.data[0].departmentId)
                    sessionStorage.setItem("Islogin", true);
                    window.location.href = "/journalallstatus";
                }
                else {
                    alert('รหัสนี้ถูกปิดการใช้งานอยู่ กรุณาติดต่อเจ้าหน้าที่')
                }
            }
        })
    }

    return (
        <div style={styles.page}>
            <form onSubmit={(e) => loginguser(e)}>
                <div style={styles.card}>
                    {/* Header */}
                    <div style={styles.cardHeader}>
                        <div style={styles.iconCircle}>
                            <FaUserLock size={36} color="#fff" />
                        </div>
                        <div style={styles.systemTitle}>E-TDS SYSTEM</div>
                        <div style={styles.systemSubtitle}>Electronic Tax Document System</div>
                    </div>

                    {/* Body */}
                    <div style={styles.cardBody}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>ชื่อผู้ใช้</label>
                            <div style={styles.inputWrapper}>
                                <FaUser size={14} color="#6abf7b" style={styles.inputIcon} />
                                <input
                                    type='text'
                                    name='username'
                                    placeholder='กรอกชื่อผู้ใช้'
                                    style={styles.input}
                                    onChange={(e) => setIsUser({ ...isUser, username: e.target.value })}
                                    onFocus={(e) => e.target.style.borderColor = '#4caf50'}
                                    onBlur={(e) => e.target.style.borderColor = '#c8e6c9'}
                                />
                            </div>
                        </div>

                        <div style={styles.inputGroup}>
                            <label style={styles.label}>รหัสผ่าน</label>
                            <div style={styles.inputWrapper}>
                                <FaLock size={14} color="#6abf7b" style={styles.inputIcon} />
                                <input
                                    type='password'
                                    name='password'
                                    placeholder='กรอกรหัสผ่าน'
                                    style={styles.input}
                                    onChange={(e) => setIsUser({ ...isUser, password: e.target.value })}
                                    onFocus={(e) => e.target.style.borderColor = '#4caf50'}
                                    onBlur={(e) => e.target.style.borderColor = '#c8e6c9'}
                                />
                            </div>
                        </div>

                        <div style={styles.buttonRow}>
                            <button
                                type='submit'
                                style={styles.btnLogin}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#388e3c'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#4caf50'}
                            >
                                เข้าสู่ระบบ
                            </button>
                            <button
                                type='reset'
                                style={styles.btnReset}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                            >
                                ล้างข้อมูล
                            </button>
                        </div>
                    </div>

                    <div style={styles.cardFooter}>© 2024 E-TDS System. All rights reserved.</div>
                </div>
            </form>
        </div>
    )
}

const styles = {
    page: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 50%, #a5d6a7 100%)',
        fontFamily: "'Segoe UI', sans-serif",
    },
    card: {
        width: 420,
        borderRadius: 20,
        boxShadow: '0 20px 60px rgba(76,175,80,0.18)',
        overflow: 'hidden',
        backgroundColor: '#fff',
    },
    cardHeader: {
        background: 'linear-gradient(135deg, #43a047, #66bb6a)',
        padding: '32px 24px 24px',
        textAlign: 'center',
    },
    iconCircle: {
        width: 68,
        height: 68,
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 14px',
        border: '2px solid rgba(255,255,255,0.4)',
    },
    systemTitle: {
        color: '#fff',
        fontSize: 22,
        fontWeight: 700,
        letterSpacing: 2,
    },
    systemSubtitle: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 12,
        marginTop: 4,
        letterSpacing: 0.5,
    },
    cardBody: {
        padding: '30px 32px 20px',
    },
    inputGroup: {
        marginBottom: 18,
    },
    label: {
        display: 'block',
        fontSize: 13,
        fontWeight: 600,
        color: '#388e3c',
        marginBottom: 6,
    },
    inputWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    inputIcon: {
        position: 'absolute',
        left: 12,
        pointerEvents: 'none',
    },
    input: {
        width: '100%',
        padding: '10px 12px 10px 36px',
        fontSize: 14,
        border: '1.5px solid #c8e6c9',
        borderRadius: 10,
        outline: 'none',
        backgroundColor: '#f9fffe',
        color: '#2e7d32',
        transition: 'border-color 0.2s',
        boxSizing: 'border-box',
    },
    buttonRow: {
        display: 'flex',
        gap: 12,
        marginTop: 26,
    },
    btnLogin: {
        flex: 1,
        padding: '11px 0',
        backgroundColor: '#4caf50',
        color: '#fff',
        border: 'none',
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        letterSpacing: 0.5,
    },
    btnReset: {
        flex: 1,
        padding: '11px 0',
        backgroundColor: '#fff',
        color: '#4caf50',
        border: '1.5px solid #a5d6a7',
        borderRadius: 10,
        fontSize: 14,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background-color 0.2s',
    },
    cardFooter: {
        textAlign: 'center',
        padding: '14px 24px',
        fontSize: 11,
        color: '#9e9e9e',
        borderTop: '1px solid #f1f8e9',
        backgroundColor: '#fafff8',
    },
}

export default Login